import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_off"}/>
}
